import React from 'react';

const SbSharedPersonalizedFilterToastWrapper = React.lazy(() =>
    import(
        /* webpackChunkName: "SbSharedPersonalizedFilterToastWrapper" */ './SbSharedPersonalizedFilterToastWrapper'
    )
);

export default function SbSharedPersonalizedFilterToastLazy(props) {
    return (
        <React.Suspense fallback="">
            <SbSharedPersonalizedFilterToastWrapper {...props} />
        </React.Suspense>
    );
}
